import { render, staticRenderFns } from "./BlockType12.vue?vue&type=template&id=315d3658&scoped=true"
import script from "./BlockType12.vue?vue&type=script&lang=ts"
export * from "./BlockType12.vue?vue&type=script&lang=ts"
import style0 from "./BlockType12.vue?vue&type=style&index=0&id=315d3658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d3658",
  null
  
)

export default component.exports